import React from 'react';
import { useParams } from 'react-router-dom';
import { useAppData } from '../../context/AppDataContext';
import { useAuth } from '../../context/AuthContext';
import useStoreAccessStatus from '../../hooks/useStoreAccessStatus';
import ManagementPageSkeleton from '../layout/ManagementPageSkeleton';
import AppLayout from '../layout/AppLayout';
import ProFeatureLockedPage from '../billing/ProFeatureLockedPage';
import { hasEntitlement } from '../../utils/storePlan';

const isAppAdminUser = (user) => {
  const userType = user?.userType || user?.user_type;
  return userType === 1 || userType === '1' || userType === 'AppAdmin' || userType === 'appAdmin';
};

const isTeamMemberUser = (userType) => userType === 2 || userType === '2' || userType === 'TeamMember';

const PlanFeatureGuard = ({
  flag,
  children,
  skeletonVariant = 'cards',
}) => {
  const params = useParams();
  const { currentStore } = useAppData();
  const { managementUser } = useAuth();
  const storeId = params.storeId || currentStore?.id;
  const shouldLoadAccess = isTeamMemberUser(managementUser?.userType || managementUser?.user_type) && Boolean(storeId);
  const { accessStatus, loading } = useStoreAccessStatus(storeId, shouldLoadAccess);

  if (isAppAdminUser(managementUser)) {
    return children;
  }

  if (shouldLoadAccess && loading && !accessStatus) {
    return (
      <AppLayout>
        <ManagementPageSkeleton variant={skeletonVariant} />
      </AppLayout>
    );
  }

  if (hasEntitlement(accessStatus?.entitlements, flag)) {
    return children;
  }

  return (
    <AppLayout>
      <ProFeatureLockedPage />
    </AppLayout>
  );
};

export default PlanFeatureGuard;
